module.exports = __webpack_public_path__ + "static/img/model-bg21.d43ed15.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg21.jpg
// module id = DsOZ
// module chunks = 0